import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from "../security/authentication.service";
import {SubscriptionComponent} from "./shared/subscription-component";
import {UserView} from "../security/model/user";
import {APP_VERSION} from "../version";
import {Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {environment} from "../environments/environment";
import {ErrorService} from "../services/error-service.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends SubscriptionComponent implements OnInit {

  readonly APP_VERSION = APP_VERSION;

  appVersion = APP_VERSION;
  user: UserView;

  acesso2f = false;

  modules = {
    candidatura: [
      {title: 'Dados Pessoais', link: ['candidatura', 'dados'], conditional: () => true},
      {title: 'Inscrição', link: ['candidatura', 'inscricao'], conditional: () => true},
      {title: 'Inscrição (2ª chamada)', link: ['candidatura', 'inscricao2f'], conditional: () => this.acesso2f},
      {title: 'Resultados', link: ['candidatura', 'resultado'], conditional: () => true}
    ]
  };

  mgmtModules = {
    gestao: [
      {title: 'Download', link: ['gestao', 'download'], permissions: ['candidatura:download.all.zip', 'candidatura:download.all.xls']},
    ],
    gestao_resultados: [
      {title: 'Resultados', link: ['gestao', 'resultados'], permissions: ['resultados:mgmt']}
    ],
    runas: [
      {title: 'Run as...', link: ['gestao', 'runas'], permissions: ['runas:runas']}
    ],
  };

  links = [];
  mgmtLinks: [{ link?: string, title?: string }?] = [];
  environment = environment;

  constructor(private authenticationService: AuthenticationService,
              private http: HttpClient,
              private errorService: ErrorService,
              private router: Router,
              private authentication: AuthenticationService) {
    super();
  }

  ngOnInit() {
    this.links.length = 0;
    this.mgmtLinks.length = 0;

    this.acesso2f = false;

    this.wrapSubscription(this.authenticationService.user().subscribe(user => {
      this.user = user;
      this.acesso2f = false;
      if (user)
        this.wrapSubscription(this.errorService.wrapCall(this.http.get<boolean>(`${environment.apiRoot}/inscricao/segunda/acesso`))
            .subscribe(acesso2f => this.acesso2f = acesso2f));

    }));
    this.wrapSubscription(
        this.authenticationService.modules()
            .subscribe(modules => {
              this.links.length = 0;
              this.mgmtLinks.length = 0;

              if (!modules)
                return;

              for (const key of Object.keys(this.modules)) {
                if (modules.indexOf(key) !== -1) {
                  for (const module of this.modules[key]) {
                    this.links.push(module);
                  }
                }
              }

              this.wrapSubscription(
                  this.authenticationService.permissions()
                      .subscribe(permissions => {
                        if (!permissions)
                          return;
                        this.mgmtLinks.length = 0;
                        for (const key of Object.keys(this.mgmtModules)) {
                          if (modules.indexOf(key) !== -1) {
                            for (const module of this.mgmtModules[key]) {
                              if (!module.permissions || module.permissions.length === 0) {
                                this.mgmtLinks.push(module);
                              } else {
                                if (permissions.filter(p => module.permissions.indexOf(`${p.domainObject}:${p.permission}`) !== -1).length > 0) {
                                  this.mgmtLinks.push(module);
                                }
                              }
                            }
                          }
                        }
                      })
              );
            })
    );
  }

  logout() {
    this.authenticationService.logout();
  }

  logoutRunas() {
    this.errorService.wrapCall(this.http.delete(`${environment.apiRoot}/runas`))
        .subscribe(() => this.authentication
            .userNoCache()
            .subscribe(() => this.router.navigate(['/']).then()));
  }

}
